<template>
  <div :style="{color: textColor, borderLeft: `2px solid ${borderColor}`, margin: '20px auto' }" class="row col-xs-12 col-sm-9 col-md-9 col-lg-9 col-sm-offset-2 col-md-offset-2 col-lg-offset-2 lib__no-padding">
    <i :style="{color: borderColor }" class="lib__no-padding-right col-indexer-width fa fa-info-circle col-xs-1 col-sm-1 col-md-1 col-lg-1"></i>
    <span class="col-xs-11 col-sm-11 col-md-11 col-lg-11" v-html="information"></span>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  name: 'more-information'
})
export default class MoreInformation extends Vue {
  @Prop({ type: String, required: true }) public information!: string
  @Prop({ type: String, required: true }) public textColor!: string
  @Prop({ type: String, required: true }) public borderColor!: string
}
</script>

<style scoped>

.col-indexer-width {
  max-width: 26px;
}
</style>
